import axiosInstance from './axiosConfig';

/**
 * 通用请求方法
 * @param {Object} options - 请求配置
 * @param {string} options.url - 请求URL
 * @param {string} options.method - 请求方法
 * @param {Object} options.data - 请求体数据（用于POST、PUT等）
 * @param {Object} options.params - URL查询参数（用于GET）
 * @param {string} options.responseType - 响应类型
 * @returns {Promise} - 请求Promise
 */
const request = async (options) => {
  try {
    const config = {
      url: options.url,
      method: options.method || 'get',
      headers: options.headers || {},
      responseType: options.responseType || 'json'
    };
    
    // 根据请求方法添加参数
    if (options.method && options.method.toLowerCase() === 'get') {
      config.params = options.data || options.params || {};
    } else {
      config.data = options.data || {};
    }
    
    // 如果有自定义headers，合并到配置中
    if (options.headers) {
      config.headers = {
        ...config.headers,
      };
    }
    
    const response = await axiosInstance(config);
    return response;
  } catch (error) {
    // 错误已经在拦截器中处理过，这里直接抛出
    throw error;
  }
};


/**
 * 通用请求方法
 * @param {Object} options - 请求配置
 * @param {string} options.url - 请求URL
 * @param {string} options.method - 请求方法
 * @param {Object} options.data - 请求体数据（用于POST、PUT等）
 * @param {Object} options.params - URL查询参数（用于GET）
 * @param {string} options.responseType - 响应类型
 * @returns {Promise} - 请求Promise
 */
const request1 = (options) => {
  try {
    const config = {
      url: options.url,
      method: options.method || 'get',
      onSuccess: options.onSuccess,
      onError: options.error,
      responseType: options.responseType || 'json'
    };
    
    // 根据请求方法添加参数
    if (options.method && options.method.toLowerCase() === 'get') {
      config.params = options.data || options.params || {};
    } else {
      config.data = options.data || {};
    }
    
    // 如果有自定义headers，合并到配置中
    if (options.headers) {
      config.headers = {
        ...config.headers,
      };
    }
    
    const response = axiosInstance(config);
    return response;
  } catch (error) {
    // 错误已经在拦截器中处理过，这里直接抛出
    throw error;
  }
};

/**
 * GET请求
 * @param {string} url - 请求URL
 * @param {Object} params - 查询参数
 * @param {Object} config - 其他Axios配置
 * @returns {Promise} - 请求Promise
 */
export const syncGet = (url, params = {}, config = {}) => {
  return request({
    url,
    method: 'get',
    data: params, // 使用data字段传递参数，在request方法中会转为params
    ...config
  });
};

/**
 * POST请求
 * @param {string} url - 请求URL
 * @param {Object} data - 请求体数据
 * @param {Object} config - 其他Axios配置
 * @returns {Promise} - 请求Promise
 */
export const syncPost = (url, data = {}, config = {}) => {
  return request({
    url,
    method: 'post',
    data,
    ...config
  });
};

/**
 * PUT请求
 * @param {string} url - 请求URL
 * @param {Object} data - 请求体数据
 * @param {Object} headers - 自定义请求头
 * @param {Object} config - 其他Axios配置
 * @returns {Promise} - 请求Promise
 */
export const put = (url, data = {}, headers = {}, config = {}) => {
  return request({
    url,
    method: 'put',
    data,
    headers,
    ...config
  });
};

/**
 * DELETE请求
 * @param {string} url - 请求URL
 * @param {Object} data - 请求体数据
 * @param {Object} headers - 自定义请求头
 * @param {Object} config - 其他Axios配置
 * @returns {Promise} - 请求Promise
 */
export const del = (url, data = {}, headers = {}, config = {}) => {
  return request({
    url,
    method: 'delete',
    data,
    headers,
    ...config
  });
};

  // GET 请求
export const get = (url, params = {}, onSuccess,onError) => {
  return request1({
    url,
    method: 'get',
    data: params, // 使用data字段传递参数，在request方法中会转为params
    onSuccess,
    onError
  });
};

// POST 请求
export const post = (url, params = {}, onSuccess,onError) => {
  return request1({
    url,
    method: 'post',
    data: params, // 使用data字段传递参数，在request方法中会转为params
    onSuccess,
    onError
  });
};

/**
 * 设置全局请求头
 * @param {string} key - 请求头键名
 * @param {string} value - 请求头值
 */
export const setGlobalHeader = (key, value) => {
  axiosInstance.defaults.headers.common[key] = value;
};

/**
 * 移除全局请求头
 * @param {string} key - 请求头键名
 */
export const removeGlobalHeader = (key) => {
  delete axiosInstance.defaults.headers.common[key];
};

/**
 * 设置auth-token到localStorage/sessionStorage和请求头
 * @param {string} token - token值
 * @param {boolean} remember - 是否记住登录（true: localStorage, false: sessionStorage）
 */
export const setAuthToken = (token) => {
 
  localStorage.setItem('auth-token', token);
  // 同时设置到请求头
  setGlobalHeader('auth-token', token);
  
};

/**
 * 清除auth-token
 */
export const clearAuthToken = () => {
  localStorage.removeItem('auth-token');
  sessionStorage.removeItem('auth-token');
  removeGlobalHeader('auth-token');
};

/**
 * 获取当前auth-token
 * @returns {string|null} - token值或null
 */
export const getAuthToken = () => {
  return localStorage.getItem('auth-token') || sessionStorage.getItem('auth-token');
};

export default {
  request,
  syncGet,
  syncPost,
  get,
  post,
  put,
  delete: del,
  setGlobalHeader,
  removeGlobalHeader,
  setAuthToken,
  clearAuthToken,
  getAuthToken,
  axios: axiosInstance
};


// WEBPACK FOOTER //
// ./src/utils/request.js